import { render, staticRenderFns } from "./StudentVsApprovers.vue?vue&type=template&id=caff17d4"
import script from "./StudentVsApprovers.vue?vue&type=script&lang=js"
export * from "./StudentVsApprovers.vue?vue&type=script&lang=js"
import style0 from "./StudentVsApprovers.vue?vue&type=style&index=0&id=caff17d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports